module.exports = __webpack_public_path__ + "static/media/light_blue_swoop.c5ad46f1.png";